import { KeyRound, Loader2 } from 'lucide-react';
import { DropdownMenuItem } from '../../../components/ui/dropdown-menu';
import { useReconnectInstagram } from '../model/useReconnectInstagram';

interface UpdateTokenDialogProps {
  accountId: string;
  onSuccess?: () => void;
}

/** Пункт меню карточки: «Переподключить Instagram» (раньше — «Обновить токен»). */
export function UpdateTokenDialog({ accountId, onSuccess }: UpdateTokenDialogProps) {
  const { reconnect, loading } = useReconnectInstagram(accountId, onSuccess);

  return (
    <DropdownMenuItem onClick={() => void reconnect()} disabled={loading}>
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <KeyRound className="h-4 w-4" />
      )}
      {loading ? 'Переподключаем…' : 'Переподключить Instagram'}
    </DropdownMenuItem>
  );
}
